import { getSessionUUID } from '../components/lib/AuthToken';
import logger from "../utils/logger";

export const getCollectionsByDate = async (date) => {
    try {
        const sessionToken = await getSessionUUID();
        
        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
        };

        const response = await fetch(`/collections/get_collections_by_date?date=${date}`, requestOptions);
        const responseBody = await response.json();

        return {
            message: 'Request successful',
            status: response.status,
            data: responseBody || [],
        };
    } catch (err) {
        logger.error("Error fetching collections:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
            data: []
        };
    }
};

export const createCollection = async (collectionData) => {
    try {
        const sessionToken = await getSessionUUID();
        
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify({ collection_data: collectionData })
        };

        const response = await fetch('/collections/create_collection', requestOptions);
        const responseBody = await response.json();

        return {
            message: 'Request successful',
            status: response.status,
            data: responseBody || null,
        };
    } catch (err) {
        logger.error("Error creating collection:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

export const updateCollection = async (collectionId, collectionData) => {
    try {
        const sessionToken = await getSessionUUID();
        
        const requestOptions = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify({ collection_data: collectionData })
        };

        const response = await fetch(`/collections/update_collection/${collectionId}`, requestOptions);
        const responseBody = await response.json();

        return {
            message: 'Request successful',
            status: response.status,
            data: responseBody || null,
        };
    } catch (err) {
        logger.error("Error updating collection:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

export const deleteCollection = async (collectionId) => {
    try {
        const sessionToken = await getSessionUUID();
        
        const requestOptions = {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
        };

        const response = await fetch(`/collections/delete_collection/${collectionId}`, requestOptions);
        const responseBody = await response.json();

        return {
            message: 'Request successful',
            status: response.status,
            data: responseBody || null,
        };
    } catch (err) {
        logger.error("Error deleting collection:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

export const bulkUpdateCollections = async (updates) => {
    try {
        const sessionToken = await getSessionUUID();

        const requestOptions = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify({ updates })
        };

        const response = await fetch('/collections/bulk_update', requestOptions);
        const responseBody = await response.json();

        return {
            message: 'Request successful',
            status: response.status,
            data: responseBody || null,
        };
    } catch (err) {
        logger.error("Error bulk updating collections:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};